import { createContext, useContext, useEffect, useState } from "react";
import { api, tokenStore, apiErr } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=logged out
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const cached = tokenStore.getUser();
    if (cached) setUser(cached); else setUser(null);
    (async () => {
      if (tokenStore.get()) {
        try {
          const { data } = await api.get("/auth/me");
          setUser(data); tokenStore.setUser(data);
        } catch {
          // keep cached user for offline; only clear if no cache
          if (!cached) { tokenStore.clear(); setUser(null); }
        }
      } else if (!cached) setUser(null);
      setReady(true);
    })();
  }, []);

  const login = async (email, password, device_id) => {
    try {
      const { data } = await api.post("/auth/login", { email, password, device_id });
      tokenStore.set(data.access_token, data.refresh_token);
      tokenStore.setUser(data.user);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: apiErr(e, "Login failed") };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    tokenStore.clear(); setUser(null);
  };

  return <AuthCtx.Provider value={{ user, ready, login, logout, setUser }}>{children}</AuthCtx.Provider>;
}
